import { render, staticRenderFns } from "./AccountPromo.vue?vue&type=template&id=7f5ae3d4&scoped=true&"
import script from "./AccountPromo.vue?vue&type=script&lang=js&"
export * from "./AccountPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5ae3d4",
  null
  
)

export default component.exports